import { Col, Form, Row, Select } from "antd";
import { InputCalendarioDate } from "components/input/InputCalendarioDate";
import { InputCalendarioRange } from "components/input/InputCalendarioRange";
import { RelatorioFilterProdutorTransportador } from "pages/relatorios/components/RelatorioFilterProdutorTransportador";
import { SelectFinanceiroBanco } from "components/select/SelectFinanceiroBanco";
import { SelectRota } from "components/select/SelectRota";
import { FormItemNoMargin } from "pages/relatorios/components/FormItemNoMargin";
import { useRelatorioStore } from "pages/relatorios/store";
import type { ApiRelatorioParams } from "pages/relatorios/types/ApiRelatorioParams";

export function FilterBar() {
	const filter = useRelatorioStore((s) => s.filter);
	const applyFilter = useRelatorioStore((s) => s.applyFilter);

	const [formFiltroAvancado] = Form.useForm<ApiRelatorioParams>();

	const handleFilter = (formValues: ApiRelatorioParams): void => {
		applyFilter(formValues);
	};

	return (
		<Form layout="vertical" form={formFiltroAvancado} onFinish={handleFilter}>
			<Row gutter={[10, 10]}>
				<RelatorioFilterProdutorTransportador showProdutor={true} showTransportador={true} />

				<Col xs={24} sm={12} md={8} lg={8} xl={6} xxl={6}>
					<FormItemNoMargin name="filterMesRef" label="Mês Ref">
						<InputCalendarioDate
							picker="month"
							format="MM/YYYY"
							placeholder="Mês Ref."
							onChange={(value) => {
								useRelatorioStore.setState({
									filter: {
										...filter,
										filterMesRef: value,
									},
								});
							}}
						/>
					</FormItemNoMargin>
				</Col>

				<Col xs={24} sm={12} md={8} lg={8} xl={6} xxl={6}>
					<FormItemNoMargin name="filterData" label="Data da Coleta">
						<InputCalendarioRange
							onChange={(value) => {
								useRelatorioStore.setState({
									filter: {
										...filter,
										filterData: value,
									},
								});
							}}
						/>
					</FormItemNoMargin>
				</Col>

				<Col xs={24} sm={12} md={8} lg={8} xl={6} xxl={6}>
					<FormItemNoMargin name="filterRotaIdpk" label="Rota">
						<SelectRota
							onChange={(_, rota) => {
								useRelatorioStore.setState({
									filter: {
										...filter,
										filterRota: rota,
									},
								});
							}}
						/>
					</FormItemNoMargin>
				</Col>

				<Col xs={24} sm={12} md={8} lg={8} xl={6} xxl={6}>
					<FormItemNoMargin name="filterTipo" label="Listar">
						<Select
							allowClear={true}
							style={{ width: "100%" }}
							placeholder="Selecione"
							defaultValue={null}
							onChange={(value) => {
								useRelatorioStore.setState({
									filter: {
										...filter,
										filterTipo: value || undefined,
									},
								});
							}}
						>
							<Select.Option value={null}>Todos</Select.Option>
							<Select.Option value={1}>Saldo Positivo</Select.Option>
							<Select.Option value={2}>Saldo Negativos</Select.Option>
						</Select>
					</FormItemNoMargin>
				</Col>

				<Col xs={24} sm={12} md={8} lg={8} xl={6} xxl={6}>
					<FormItemNoMargin name="filterBancoIdpk" label="Banco">
						<SelectFinanceiroBanco
							onChange={(idpk) => {
								useRelatorioStore.setState({
									filter: {
										...filter,
										filterBancoIdpk: idpk || 0,
									},
								});
							}}
						/>
					</FormItemNoMargin>
				</Col>
			</Row>
		</Form>
	);
}
